globalThis.window.global = globalThis.window;
